import type { SVGProps } from 'react';

export function DogIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.4 6.6c.623 0 1.133.472 1.193 1.076l.01.248A1.204 1.204 0 0 0 4.8 9h6.716l5.284 2.265V20.4c0 .664-.536 1.2-1.2 1.2h-1.2c-.664 0-1.2-.536-1.2-1.2v-4.924a6.56 6.56 0 0 1-3 .724 6.56 6.56 0 0 1-3-.724V20.4c0 .664-.536 1.2-1.2 1.2H4.8c-.664 0-1.2-.536-1.2-1.2v-9.21A3.595 3.595 0 0 1 1.2 7.8c0-.664.536-1.2 1.2-1.2m12.143-5.4a.92.92 0 0 1 .735.367l.622.833h1.954a1.8 1.8 0 0 1 1.271.529l.675.671h2.1c.499 0 .9.401.9.9v.9a3 3 0 0 1-3 3h-2.4l-.262 1.05-4.677-2.003 1.185-5.52a.915.915 0 0 1 .896-.727M18 4.05a.75.75 0 0 0-.75.75c0 .412.337.75.75.75s.75-.338.75-.75a.75.75 0 0 0-.75-.75" />
    </svg>
  );
}
